import styled from "styled-components"
import PanelCompanyUser from "./component"

export default styled(PanelCompanyUser)`
    .button-add-new {
        margin-bottom: 24px;
        width: 100%;
    }

`